define([
  'app',
  '../helpers/dropdown'
], function (app, Dropdown) {
  return app.Marionette.ItemView.extend({
    template: false,

    ui: {
      topicTypeButton: '.radio-box-button',
      subForumDropdown: '.editor__subject select'
    },

    events: {
      'change @ui.topicTypeButton': 'onChangeTopicType'
    },

    options: {
      type: 0,
      forumTree: []
    },

    /**
     *
     * @param options
     * @returns {exports}
     */
    initialize: function () {
      var dropdown = new Dropdown({ el: this.ui.subForumDropdown, create: false })

      this.subForumDropdown = dropdown.el.selectize
      this.currentType = this.getOption('type') || 0
      this.previousType = null
      this.updateSubForumDropdown()

      return this
    },

    /**
     *
     * @param newType
     * @returns {exports}
     */
    switchTopicType: function (newType) {
      this.previousType = this.currentType
      this.currentType = newType
      this.updateSubForumDropdown()

      return this
    },

    /**
     *
     * @param e
     * @returns {exports}
     */
    onChangeTopicType: function (e) {
      this.ui.topicTypeButton.removeClass('is-active').filter(e.currentTarget).addClass('is-active')
      this.switchTopicType(e.target.value)

      return this
    },

    /**
     *
     * @returns {exports}
     */
    updateSubForumDropdown: function () {
      var self = this
      var optionsList = this.options.forumTree
      var currentSelected = this.subForumDropdown.getValue()
      var contentTypeIdea = 2
      // Remove the current options
      this.subForumDropdown.options = {}
      this.subForumDropdown.clearOptionGroups()
      this.subForumDropdown.clearOptions()

      // Loop over all forums, find the
      app._.forEach(optionsList, function (category, categoryID) {
        categoryID = categoryID.toString()

        self.subForumDropdown.addOptionGroup(categoryID, { label: category.label })

        app._.forEach(category.subForums, function (forum, forumID) {
          if (app._.contains(forum.types, parseInt(self.currentType, 10))) {
            self.subForumDropdown.addOption({ text: forum.label, value: forumID, optgroup: categoryID })
          }
        })
      })
      // Do not re-select the 'old' value when selecting ideation manually
      // If previousType is null, create topic in category view clicked, retain category selection for ideation
      if ((this.currentType === contentTypeIdea && this.previousType != null) || this.previousType === contentTypeIdea) {
        this.subForumDropdown.clear()
      } else {
      // Re-select the 'old' value when question or conversation
        this.subForumDropdown.setValue(currentSelected)
      }

      return this
    }
  })
})
